import { mapState, mapGetters, mapActions } from 'vuex'

export const memberDetailsComputed = {
  ...mapState('memberDetails', {
    loading: (state) => state.loading,
  }),
  ...mapGetters('memberDetails', ['getDetails', 'getErrors']),
}

export const memberDetailsMethods = mapActions('memberDetails', [
  'getDetailsById',
  'resetMemberDetails',
])
